import i18n from '@/shared/i18n';
import BaseModel from '@/core/components/input-widget/BaseModel';

export default class BatchUpdateReceiptModel extends BaseModel {
  receipt_uuid = null;
  note = '';

  attributeLabels = {
    receipt_uuid: i18n.t('Receipt'),
    note: i18n.t('Note'),
  };

  rules = {
    receipt_uuid: 'required',
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
